import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EventsApiService } from './events-api.service';
import { EventsEffects } from './events.effects';
import {
  EVENTS_STORE_KEY,
  eventsInitialState,
  eventsReducer
} from './events.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(EVENTS_STORE_KEY, eventsReducer, {
      initialState: eventsInitialState
    }),
    EffectsModule.forFeature([EventsEffects])
  ],
  providers: [EventsApiService]
})
export class EventsStoreModule {}
